import en from './en.json';
import fr from './fr.json';

export const siteI18n = {
  fr,
  en,
};
